const BILLS_LIST = {
  PAGE_TITLE: 'ليست صورتحساب ها | رایچت',

  HEADING_TITLE: 'ليست صورتحساب ها',
  HEADING_SUBTITLE:
    'شما می‌توانید نوع و زمان پکیج، تاریخ، وضعیت فاکتور و جزئیات آن‌ها (درگاه، شناسه فاکتور و ...) را مشاهده نموده و رسید پرداختی نیز دریافت نمایید.',

  THERE_IS_NO_BILL:
    'شما تا به حال پرداختی نداشتيد، ليست صورتحساب ها خالی می باشد.',

  BILL_ID: 'شماره فاکتور',
  SERVICE_TYPE: 'نوع سرويس',
  DESCRIPTION: 'شرح',
  DATE: 'تاریخ',
  AMOUNT: 'مبلغ',
  STATUS: 'وضعیت',
  OPERATION: 'عملیات',

  UNPAID_BADGE: 'پرداخت نشده',
  PAID_BADGE: 'پرداخت شده',

  OFFICIAL_BILL_TOOLTIP:
    'دریافت فاکتور تنها برای صورتحساب‌های پرداختی امکان‌پذیر است.',

  NOTF_TITLE: 'کاربر گرامی رایچت',
  NOTIF_TEXT:
    'جهت دریافت فاکتور رسمی پرداخت خود نیاز است که ابتدا اطلاعات خود را تکمیل نمایید.',

  OFFICIAL_BILL_BTN: 'فاکتور رسمی',
  PRE_INVOICE_BTN: 'پیش فاکتور',

  PACKAGE_PURCHASE_TITLE: 'پلتفرم گفتگوی آنلاین',
  CONV_CHARGE_PURCHASE_TITLE: 'شارژ مکالمه',

  BILL_DETAILS: 'جزئیات',

  DETAILS_MODAL: {
    TITLE: 'اطلاعات پرداخت',
    CODE: 'كد پيگيری',
    PAYMENT_GATEWAY: 'درگاه پرداخت',
    PAYMENT_METHOD: 'نوع تراكنش',
    ID: 'شناسه فاکتور',
  },

  PAYMENT_AMOUNT_SUFFIX: 'تومان',

  RECEIPT_FACTOR: {
    TITLE: 'رسید دریافت وجه',
    NAME_LABEL: 'نام شخص حقیقی/حقوقی :',
    PAY_DATE: 'تاریخ پرداخت :',
    FACTOR_NUMBER: 'شماره فاکتور :',
    TOTAL_COST: 'جمع کل',
    DESCRIPTION: 'شرح خدمات',
    ROW: 'ردیف',
    NUM: 'عدد',
    EXTRA_CREDIT: 'اعتبار مازاد مكالمه',
    FOOTER: 'این رسید صرفا جهت تایید پرداخت مشتری می باشد.',
  },

  OFFICIAL_FACTOR: {
    PACKAGE_PURCHASE_DESC: 'پلتفرم گفتگوی آنلاین',
    CHARGE_PURCHASE_DESC: 'پلتفرم گفتگوی آنلاین - شارژ مکالمه',
    ADDRESS: 'آدرس:',
    CURRENCY_SUFFIX: 'ریال',
    FACTOR_NUM_LABEL: 'شماره',
    FACTOR_REFERENCE: 'ارجاع',
    PRINT_DATE: 'تاریخ چاپ',
    PAY_DATE: 'تاریخ پرداخت',
    INDEX: 'تعداد',
    RAW_PRICE: 'ملبغ',
    DISCOUNT: 'تخفیف',
    TAX: 'مالیات',
    LOGISTICS: 'حمل و نقل',
    TOTAL_PRICE: 'مبلغ کل',
    SELLER: 'فروشنده',
    ECONOMIC_NUM: 'کد اقتصادی',
    REGISTER_NUM: 'شماره ثبت',
    COUNTRY: 'کشور',
    STATE: 'استان',
    CITY: 'شهر',
    POSTAL_CODE: 'کد پستی',
    NATIONAL_ID: 'شناسه ملی',
    PHONE: 'تلفن',
    BUYER: 'خریدار',
    UNIT_PRICE: 'مبلغ واحد',
    UNIT: 'واحد',
    DESC: 'شرح',
  },

  BANK_CHOICE_TITLE: 'انتخاب بانک',
  CHOOSE_BANK_ERROR: 'بانک مورد نظر را انتخاب کنید.',
  CONTINUE_PURCHASE: 'ادامه فرايند خريد',
};

export default BILLS_LIST;
